import * as React from "react";
import {
  AlignItems,
  BackgroundColor,
  BorderColor,
  BorderStyle,
  BorderWidth,
  Button,
  classNames,
  Display,
  FlexDirection,
  JustifyContent,
  Margin,
  Padding,
  RadioButton,
  TextAlign,
  TextColor,
  Width
} from "@snoam/pinata";
import { IPaymentDetails, IUserInfo } from "../CustomTypes";

interface IVippsPaymentMethodProps {
  callCreateOrder: (phoneNumber: string) => void;
  disclaimer?: JSX.Element;
  loading: boolean,
  paymentDetails: IPaymentDetails;
  selectedPaymentMethodId: number;
  userInfo: Pick<IUserInfo, "cellphone" | "phoneNumber" | "vippsEnabled">;
}

export const styleClass = {
  container: classNames(
    BorderColor.BORDER_NEUTRAL_2,
    BorderWidth.BORDER_B_1,
    BorderStyle.BORDER_SOLID
  ),
  radioButton: classNames(Margin.MR_4, Margin.MT_1),
  text: classNames(
    Display.FLEX,
    JustifyContent.JUSTIFY_BETWEEN,
    Padding.PL_2,
    Padding.PR_6,
    Padding.PT_4,
    Padding.PB_2,
    BackgroundColor.BG_WHITE
  ),
  vippsInput: classNames(
    Display.FLEX,
    FlexDirection.FLEX_COL,
    AlignItems.ITEMS_CENTER,
    Width.W_FULL
  ),
  warningText: classNames(
    TextColor.TEXT_WARNING,
    TextAlign.TEXT_CENTER,
    Margin.MB_2
  ),
};

const VippsPaymentMethod: React.FunctionComponent<IVippsPaymentMethodProps> = (props) => {
  const {
    callCreateOrder,
    children,
    disclaimer,
    loading,
    paymentDetails,
    selectedPaymentMethodId,
    userInfo: {
      cellphone,
      phoneNumber,
      vippsEnabled,
    },
  } = props;
  const selected = selectedPaymentMethodId === paymentDetails.id;
  const createVippsPaymentMethod: React.MouseEventHandler<HTMLButtonElement> & React.KeyboardEventHandler<HTMLButtonElement> = (e) => {
    if (e.key === "Enter" || e.key === undefined) {
      const phone = cellphone || phoneNumber;
      callCreateOrder(phone ? `47${phone}` : undefined);
    }
  };
  const input = (
    <div key={paymentDetails.id} className={styleClass.vippsInput}>
      <Button
        onClick={createVippsPaymentMethod}
        onKeyDown={createVippsPaymentMethod}
        disabled={loading}
        text={loading ? `Videresender til Vipps...` : `Betal med Vipps`}
      />
    </div>
  );

  if (!vippsEnabled) {
    return null;
  }

  return (
    <div className={styleClass.container} key={paymentDetails.id}>
      <label htmlFor={`payment-method-${paymentDetails.id}`}>
        <div className={styleClass.text}>
          <div>
            <RadioButton
              id={`payment-method-${paymentDetails.id}`}
              value={'' + paymentDetails.id}
            />
          </div>
          {children}
        </div>
      </label>
      {selected && (
        <>
          {disclaimer}
          {input}
        </>
      )}
    </div>
  );
};

VippsPaymentMethod.displayName = "VippsPaymentMethod";

export default VippsPaymentMethod;
